import enTranslation from './translations/en';
// These two German translations are for example purposes only
import deTranslation from './translations/de';
import deAtTranslation from './translations/de-at';
import { get as _get } from 'lodash-es';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
// No need to pass in the `de-AT` locale, since it's included in the `de` locale-data pack
addLocaleData([...en, ...de]);

const Translation = {
  defaultLocale: 'en',
  translations: {
    en: enTranslation,
    de: deTranslation,
    'de-at': deAtTranslation,
  },

  /**
   * Get locale passed into configuration object
   *
   * @returns {*}
   */
  getLocale: function() {
    let requestedLocale = _get(window, 'compatioConfig.locale', 'en')
      .toLowerCase() // Standardize strings for comparison
      .replace('_', '-'); // Convert all strings to lowercase to standardize data passed by different platforms

    if (this.translations.hasOwnProperty(requestedLocale)) {
      return requestedLocale;
    }

    /**
     * If the user has a specific local selected (e.g., en_US), we might not have a translation for that specific
     * locale. However we may have a translation for the "language" (e.g., en) section of the locale
     */
    const language = this.extractLanguageFromLocale(requestedLocale);
    if (this.translations.hasOwnProperty(language)) {
      return language;
    }

    return this.defaultLocale;
  },

  /**
   * Extracts the language from a locale
   *
   * Input: en_US Output: en
   * Input: en Output: en
   *
   * @param locale
   * @returns {*}
   */
  extractLanguageFromLocale: function(locale) {
    const language = locale.match(/[a-z]+/i);
    if (language !== null) {
      return language[0];
    }
    return false;
  },

  getTranslations: function(locale) {
    return this.translations[locale];
  },
};

export default Translation;
